import { PROCESS } from "@/data/assets";
import { Reveal, SectionTag } from "./Reveal";
import { ArrowRight } from "lucide-react";

export const Process = () => (
  <section
    id="process"
    className="relative py-24 md:py-36 px-5 md:px-10 bg-[#0c0c0c] border-y border-white/10"
    data-testid="process-section"
  >
    <div className="mx-auto max-w-[1400px]">
      <div className="mb-14 max-w-3xl">
        <SectionTag index="02" label="The Process" />
        <h2 className="font-display text-[clamp(2.6rem,7vw,6rem)] text-white">
          CAD <span className="text-white/30">→</span> Print{" "}
          <span className="text-white/30">→</span>{" "}
          <span className="text-[#e31e24]">Fitted</span>
        </h2>
      </div>

      <div className="grid md:grid-cols-3 gap-6 md:gap-8">
        {PROCESS.map((step, i) => (
          <Reveal key={step.n} delay={i * 0.12}>
            <div
              className="group relative"
              data-testid={`process-step-${step.n}`}
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-black mb-6">
                <img
                  src={step.img}
                  alt={step.title}
                  className="h-full w-full object-cover grayscale opacity-70 transition-all duration-700 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0c0c0c] via-transparent to-transparent" />
                <span className="absolute top-4 left-4 font-display text-6xl text-[#e31e24] drop-shadow-lg">
                  {step.n}
                </span>
                {i < PROCESS.length - 1 && (
                  <ArrowRight
                    className="hidden md:block absolute -right-7 top-1/2 -translate-y-1/2 text-[#e31e24] z-10"
                    size={26}
                  />
                )}
              </div>
              <h3 className="font-display text-3xl text-white mb-3">
                {step.title}
              </h3>
              <p className="text-white/55 text-sm leading-relaxed">
                {step.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
